interface MockupTagProps {
  note?: string;
  className?: string;
}

// Visible MOCKUP labels are switched off. The tag stays in the code as a marker,
// so sample content can still be found and replaced before launch (search for "MockupTag").
export function MockupTag(_props: MockupTagProps) {
  return null;
}